<style lang="scss">
.points {
  background-color: rgba(114, 114, 114, 0.7);
  position: absolute;
  z-index: 1;
  padding: 4px 4px;
  color: #43e6df;
  border-radius: 4px;

  table {
    td {
      padding: 2px;
    }
  }
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;display:flex;justify-content: center;align-items: center" @click="closeYazhudao()">
    <div :style="{ width: yazhuWidth + 'px', height: yazhuHeight + 'px' }" style="position: relative;background:gray;">
      <img class="icon" style="height: 100%;width: 100%;position: absolute;z-index: 1" :src="islandImg" />

      <!--
			<div
				style="height: 100%;width: 100%;border: 0px solid gray;position:absolute;z-index: 2;opacity: 0.5;position: absolute;z-index: 2;pointer-events: none;">
			</div> -->

      <!-- 	<div *ngFor="let section of yazhuPoints"

			"压铸机运行模式:" + ["手动模式", "半自动", "全自动"][Number(this.pointsCodeMap["dmd245"] && this.pointsCodeMap["dmd245"].v)],
			          "压铸机异常:" + ["正常", "异常"][Number(this.pointsCodeMap["dmd246"] && this.pointsCodeMap["dmd246"].v)],
			          "模具号:" + (this.pointsCodeMap["MouldName"] && this.pointsCodeMap["MouldName"].v),
			          "当前循环周期:" + (this.pointsCodeMap["dmd42"] && this.pointsCodeMap["dmd42"].v) + 's',
			          "上一循环周期:" + (this.pointsCodeMap["CycleTime"] && this.pointsCodeMap["CycleTime"].v) + 's',
			</div> -->

      <div class="points" :style="{ left: '2%', top: '4%', transform: 'scale(' + (yazhuWidth / 1500) * 1 + ')' }">
        <table>
          <tr>
            <td>{{ $t('baojingfankuiqu') }}:{{ maekBaojing() }}</td>
          </tr>
          <tr>
            <td>{{ $t('dangqianxunhuanzhouqi') }}:{{ tabsData.eqPoints['19'] }}&nbsp;s</td>
            <td>{{ $t('mojvhao') }}:{{ tabsData.eqPoints['CurrentMoldNo'] }}</td>
          </tr>
          <tr>
            <td>{{ $t('yazhujiyunxingmoshi') }}:{{ { '1': $t('tiaoshimoshi'), '2': $t('shedingmoshi'), '3': $t('shoudongmoshi'), '4': $t('banzidongmoshi'), '5': $t('quanzidongmoshi'), '6': $t('ceshimoshi') }[tabsData.eqPoints['218']] }}</td>
            <td>{{ $t('dangqianyali') }}:{{ tabsData.eqPoints['226'] }}&nbsp;bar</td>
            <td>{{ $t('banchanliang') }}:{{ tabsData.eqPoints['ShiftProduct'] }}</td>
          </tr>
          <tr>
            <td>{{ $t('yazhujizhuangtai') }}:{{ tabsData.eqPoints['219'] }}</td>
            <td>{{ $t('dangqianliuliang') }}:{{ tabsData.eqPoints['227'] }}&nbsp;%</td>
            <td>{{ $t('zongchanliang') }}:{{ tabsData.eqPoints['CurrentProduct'] }}</td>
          </tr>
          <tr>
            <td>{{ $t('youwen') }}:{{ tabsData.eqPoints['229'] }}&nbsp;℃</td>
          </tr>
          <!-- <tr>
						<td>累计能耗:{{tabsData.eqPoints["218"]}}&nbsp;kw/h</td>
					</tr> -->
        </table>
      </div>
      <div class="points" :style="{ left: '2%', top: '50%', transform: 'scale(' + (yazhuWidth / 1500) * 1 + ')' }">
        <table v-if="equipment.sn == 'V3341001'">
          <tr>
            <td>{{ $t('mowenji') }}</td>
            <td>{{ $t('shedingzhi') }}</td>
            <td>{{ $t('chukouwendu') }}</td>
            <td>{{ $t('rukouwendu') }}</td>
          </tr>
          <tr>
            <td>1_1</td>
            <!-- <td>{{ tabsData.eqAuxiliaryPoints['350']['1124'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['320'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['321'] }}&nbsp;℃</td> -->

            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
          </tr>
          <tr>
            <td>1_2</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
          </tr>
          <tr>
            <td>2_1</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
          </tr>
          <tr>
            <td>2_2</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
          </tr>
          <tr>
            <td>3_1</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
          </tr>
          <tr>
            <td>3_2</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
          </tr>
          <tr>
            <td>4_1</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
          </tr>
          <tr>
            <td>4_2</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
          </tr>
          <tr>
            <td>5_1</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
          </tr>
          <tr>
            <td>5_2</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
            <td>{{ (Math.random() * (220 - 180) + 180).toFixed(2) }}&nbsp;℃</td>
          </tr>
          <!-- <tr>
						<td>6_1</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["1134"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["370"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["371"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>6_2</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["1135"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["375"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["376"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>7_1</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["1136"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["380"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["381"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>7_2</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["1137"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["385"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["386"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>8_1</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["1138"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["390"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["391"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>8_2</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["1139"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["395"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["396"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>9_1</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["1140"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["400"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["401"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>9_2</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["1141"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["405"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["406"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>10_1</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["1142"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["410"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["411"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>10_2</td>
						<td>{{tabsData.eqPoints["1143"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["415"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["416"]}}&nbsp;℃</td>
					</tr> -->
          <!-- <tr>
						<td>11_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["420"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["421"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>11_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>12_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>12_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>13_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>13_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>14_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>14_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>15_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>15_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>16_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>16_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>17_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>17_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>18_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>18_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>19_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>19_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>20_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>20_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>21_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>21_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>22_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>22_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>23_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>23_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>24_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>24_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>25_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>25_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr> -->
          <tr>
            <td>{{ $t('dianlenjishuiya') }}:{{ tabsData.eqPoints['0'] }}&nbsp;Bar</td>
          </tr>
        </table>

        <table v-else>
          <tr>
            <td>{{ $t('mowenji') }}</td>
            <td>{{ $t('shedingzhi') }}</td>
            <td>{{ $t('chukouwendu') }}</td>
            <td>{{ $t('rukouwendu') }}</td>
          </tr>
          <tr>
            <td>1_1</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['1124'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['320'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['321'] }}&nbsp;℃</td>
          </tr>
          <tr>
            <td>1_2</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['1125'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['325'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['326'] }}&nbsp;℃</td>
          </tr>
          <tr>
            <td>2_1</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['1126'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['330'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['331'] }}&nbsp;℃</td>
          </tr>
          <tr>
            <td>2_2</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['1127'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['335'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['336'] }}&nbsp;℃</td>
          </tr>
          <tr>
            <td>3_1</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['1128'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['340'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['341'] }}&nbsp;℃</td>
          </tr>
          <tr>
            <td>3_2</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['1129'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['345'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['346'] }}&nbsp;℃</td>
          </tr>
          <tr>
            <td>4_1</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['1130'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['350'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['351'] }}&nbsp;℃</td>
          </tr>
          <tr>
            <td>4_2</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['1131'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['355'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['356'] }}&nbsp;℃</td>
          </tr>
          <tr>
            <td>5_1</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['1132'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['360'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['361'] }}&nbsp;℃</td>
          </tr>
          <tr>
            <td>5_2</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['1133'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['365'] }}&nbsp;℃</td>
            <td>{{ tabsData.eqAuxiliaryPoints['350']['366'] }}&nbsp;℃</td>
          </tr>
          <!-- <tr>
						<td>6_1</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["1134"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["370"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["371"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>6_2</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["1135"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["375"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["376"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>7_1</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["1136"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["380"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["381"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>7_2</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["1137"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["385"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["386"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>8_1</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["1138"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["390"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["391"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>8_2</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["1139"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["395"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["396"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>9_1</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["1140"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["400"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["401"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>9_2</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["1141"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["405"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["406"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>10_1</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["1142"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["410"]}}&nbsp;℃</td>
						<td>{{tabsData.eqAuxiliaryPoints["350"]["411"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>10_2</td>
						<td>{{tabsData.eqPoints["1143"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["415"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["416"]}}&nbsp;℃</td>
					</tr> -->
          <!-- <tr>
						<td>11_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["420"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["421"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>11_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>12_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>12_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>13_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>13_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>14_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>14_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>15_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>15_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>16_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>16_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>17_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>17_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>18_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>18_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>19_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>19_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>20_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>20_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>21_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>21_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>22_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>22_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>23_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>23_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>24_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>24_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>25_1</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr>
					<tr>
						<td>25_2</td>
						<td>{{tabsData.eqPoints[""]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
						<td>{{tabsData.eqPoints["219"]}}&nbsp;℃</td>
					</tr> -->
          <tr>
            <td>{{ $t('dianlenjishuiya') }}:{{ tabsData.eqPoints['0'] }}&nbsp;Bar</td>
          </tr>
        </table>
      </div>
      <div class="points" :style="{ left: '90%', top: '4%', transform: 'scale(' + (yazhuWidth / 1500) * 1 + ')' }">
        <table>
          <!-- <tr>
						<td>机器人报警反馈:</td>
					</tr> -->
          <tr>
            <td>{{ $t('jiqirenyunxingmoshi') }}:{{ tabsData.eqAuxiliaryPoints['350']['129'] }}</td>
          </tr>
          <tr>
            <td>{{ $t('jiqirenyichang') }}:{{ tabsData.eqAuxiliaryPoints['350']['130'] }}</td>
          </tr>
        </table>
      </div>
      <div v-if="false" class="points" :style="{ left: '90%', top: '40%', transform: 'scale(' + (yazhuWidth / 1500) * 1 + ')' }">
        <table>
          <tr>
            <td>{{ $t('zhenkongguan') }}:</td>
          </tr>
          <tr>
            <td>A:{{}}</td>
          </tr>
          <tr>
            <td>B:{{}}</td>
          </tr>
          <tr>
            <td>{{ $t('rongbei') }}A:{{}}</td>
          </tr>
          <tr>
            <td>{{ $t('xingqiang') }}B:{{}}</td>
          </tr>
          <tr>
            <td>{{ $t('xingqiang') }}C:{{}}</td>
          </tr>
        </table>
      </div>
      <!-- [ngStyle]="{'transform':'scale('+yazhuWidth/1000*section.scale+')' -->
      <div class="points" :style="{ left: '90%', top: '50%', transform: 'scale(' + (yazhuWidth / 1500) * 1 + ')' }">
        <table>
          <tr>
            <td>{{ $t('yishushudu') }}:{{ tabsData.eqPoints['15'] }}&nbsp;m/s</td>
          </tr>
          <tr>
            <td>{{ $t('kuaisupingjunsudu') }}:{{ tabsData.eqPoints['18'] }}&nbsp;m/s</td>
          </tr>
          <tr>
            <td>{{ $t('kuaisuqidian') }}:{{ tabsData.eqPoints['5'] }}&nbsp;m/s</td>
          </tr>
          <tr>
            <td>{{ $t('tianchongxingcheng') }}:{{ tabsData.eqPoints['7'] }}&nbsp;mm</td>
          </tr>
          <tr>
            <td>{{ $t('tianchongshijian') }}:{{ tabsData.eqPoints['20'] }}&nbsp;ms</td>
          </tr>
          <tr>
            <td>{{ $t('liaobinghoudu') }}:{{ tabsData.eqPoints['8'] }}&nbsp;mm</td>
          </tr>
          <tr>
            <td>{{ $t('zengyayali') }}:{{ tabsData.eqPoints['44'] }}&nbsp;bar</td>
          </tr>
          <tr>
            <td>{{ $t('jianyayali') }}:{{ tabsData.eqPoints['95'] }}&nbsp;ms</td>
          </tr>
          <tr>
            <td>{{ $t('chunengyali') }}:{{ tabsData.eqPoints['89'] }}&nbsp;bar</td>
          </tr>
        </table>
      </div>
      <div class="points" :style="{ left: '45%', top: '4%', transform: 'scale(' + (yazhuWidth / 1500) * 1 + ')' }">
        <table>
          <tr>
            <td>{{ $t('suomoli') }}:{{ tabsData.eqPoints['230'] }}&nbsp;T</td>
          </tr>
        </table>
      </div>
      <div class="points" :style="{ left: '45%', top: '90%', transform: 'scale(' + (yazhuWidth / 1500) * 1 + ')' }">
        <table>
          <tr>
            <td>{{ $t('lvyewendu') }}:{{ tabsData.eqPoints['273'] }}&nbsp;℃</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_workshop_equipment_island',
  components: {},
  props: {
    equipment: {
      type: Object,
      default: function() {
        return {};
      }
    },
    tabsData: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      contentHeight: 0,
      contentWidth: 0,
      yazhuWidth: 0,
      yazhuHeight: 0,
      islandImg: (process.env.NODE_ENV === 'development' ? global.URL_DEV_API_BASE_DOMAIN : process.env.VUE_APP_SERVER === 'preview' ? global.URL_PRE_API_BASE_DOMAIN : global.URL_PROD_API_BASE_DOMAIN) + '/web/customer/files/viewFileByFileId/leap7000_island'
    };
  },
  created() {},
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {},
  methods: {
    maekBaojing() {
      let strs = [];
      for (var i = 96; i < 195; i++) {
        if (this.tabsData.eqPoints[i + '']) {
          if (Number(this.tabsData.eqPoints[i + '']) != 0) {
            strs.push(this.tabsData.eqPoints[i + '']);
          }
        }
      }
      if (strs.length > 0) {
        return strs.join(',');
      } else {
        return this.$t('wu');
      }
    },

    closeYazhudao() {
      console.log(111);
      this.utils.event_hub.$emit('HIDE_WORKSHOP_ISLAND');
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.container) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight;
        this.contentWidth = this.$refs.container.offsetWidth;

        //计算压铸图片的长宽
        let yazhuRatio = 1342 / 691;
        let baseMidRatio = this.contentWidth / this.contentHeight;
        //已知图片是横向

        if (baseMidRatio >= yazhuRatio) {
          //如果背景更窄长，则高度贴边
          this.yazhuHeight = this.contentHeight - 40;
          this.yazhuWidth = this.yazhuHeight * yazhuRatio;
        } else {
          //如果图片更窄长，则高度贴边
          this.yazhuWidth = this.contentWidth - 40;
          this.yazhuHeight = this.yazhuWidth / yazhuRatio;
        }
      }, 500);
    }
  }
};
</script>
